(() => {
  document.querySelectorAll('.ep-region-form').forEach(form => {
    if (form.dataset.regionReady) return;
    form.dataset.regionReady = 'true';
    const controls = [...form.querySelectorAll('[data-region-current]')];
    // A cached form selection must not contradict the country/language printed
    // by Shopify in this page. User changes remain independent until submission.
    const restoreRenderedSelection = () => controls.forEach(select => {
      const rendered = select.dataset.regionCurrent;
      if ([...select.options].some(option => option.value === rendered)) select.value = rendered;
    });
    restoreRenderedSelection();
    window.addEventListener('pageshow', restoreRenderedSelection);
    const menu = form.closest('[data-ep-language]');
    if (!menu) return;
    document.addEventListener('click', event => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
    menu.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !menu.open) return;
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
})();
